module.exports = __webpack_public_path__ + "static/media/pipeten_ok.64fe7d8a.jpg";